import React from 'react'
import footerimg from "../Images/image 2172.jpg";
import './Footer.css'

function Footer() {
  return (
    <div>

      <div className="container-fluid pl-0">
        <div className="row">
          <div className="col-lg-6 pr-0">
            <div>
              <img src={footerimg} className='footer-img-div12' alt="" />
            </div>
          </div>

          <div className="col-lg-6 footer-text-div12">
            <div>
              <h2>
                Contact us to request <br></br>
                <span>a quote today.</span>
              </h2>
              <div className="footer-email-div1">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <circle cx="16.5" cy="16.5" r="16.5" fill="#F7B53C" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M24.7345 9C25.3526 9 25.9014 9.2714 26.2468 9.69119L16.2168 17.3965L6.27625 9.83111C6.60862 9.33269 7.20808 9 7.89238 9H24.7345ZM6 21.8268V11.1984L13.1326 16.6268L6.0147 22.0439C6.005 21.9728 6 21.9003 6 21.8268ZM6.65232 23.1362C6.98444 23.4003 7.41802 23.5602 7.89238 23.5602H24.7345C25.1422 23.5602 25.5198 23.4421 25.8288 23.2412L18.2495 17.4186L16.8865 18.4656C16.5011 18.7618 15.9395 18.763 15.5525 18.4685L14.169 17.4155L6.65232 23.1362ZM19.2802 16.6268L26.5752 22.231C26.609 22.1013 26.6269 21.966 26.6269 21.8268V10.9828L19.2802 16.6268Z"
                      fill="#070707"
                    />
                  </svg>
                </div>
                <div>
                  <a href='mailto:info@pkcargo.co.uk'>
                    <p>Send us an email</p>
                    <h5>info@pkcargo.co.uk</h5>
                  </a>

                </div>
              </div>

              <div className="footer-email-div1">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                    <circle cx="16.5" cy="16.5" r="16.5" fill="#F7B53C" />
                    <path d="M10.5919 13.9709C12.1697 18.2753 13.8032 19.9927 17.9588 21.822L16.1579 24.3512C11.386 22.0666 9.00919 18.2156 7.88979 15.2103L10.5919 13.9709Z" fill="#070707" />
                    <path d="M11.9144 8.02563C12.7581 8.02233 13.3996 8.72438 13.3421 9.51935C13.2516 10.7704 13.348 11.6729 13.6074 12.7917C13.7499 13.4063 13.4275 14.0305 12.9151 14.4325C12.2245 14.9744 11.6969 15.6648 11.2775 16.2592C10.6963 17.083 8.69603 17.0238 8.25367 16.1263C7.34456 14.2819 6.72846 10.8838 8.05602 8.58792C8.26455 8.2273 8.68442 8.03826 9.11949 8.03656L11.9144 8.02563Z" fill="#070707" />
                    <path d="M24.7212 21.6748C24.8262 20.8842 24.1653 20.1983 23.3228 20.1566C21.9968 20.0911 21.0596 19.8922 19.9148 19.5144C19.2859 19.3068 18.591 19.5341 18.1068 19.9661C17.4542 20.5485 16.6649 20.9601 15.9897 21.2818C15.0538 21.7276 14.8755 23.6101 15.7657 24.1328C17.5952 25.2069 21.0932 26.1932 23.6661 25.2246C24.0703 25.0725 24.3195 24.7016 24.3736 24.2939L24.7212 21.6748Z" fill="#070707" />
                  </svg>
                </div>

                <div>
                  <a href='tel:+447510074850'>
                    <p>Contact Us</p>
                    <h5>+44 7510074850</h5>
                  </a>
                </div>

              </div>


              <div className='footer-last-sec-text-div56'>
                <div>
                  <p>© 2026 PKCARGO. All Rights Reserved |  <br className=' d-md-none d-block' /> Design and Develop by <a href='#' target='_blank' >M. Hamid</a></p>
                  <div className='footer-last-sec-text-div89'>
                    <a href='https://www.facebook.com/pkcargo.co.uk' target='_blank'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                        <circle cx="16.33" cy="16.33" r="16.33" fill="#F7B53C" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1098 12.6776H18.2726C18.028 12.6777 17.7935 12.7749 17.6206 12.9478C17.4477 13.1207 17.3505 13.3552 17.3504 13.5998V15.4449H20.1098L19.7056 18.2114H17.3504V23.2853H14.316V18.2114H11.8105V15.4453H14.2835L14.316 12.8195L14.3069 11.8784C14.3039 11.5605 14.3639 11.2452 14.4834 10.9506C14.6029 10.6561 14.7796 10.3881 15.0033 10.1622C15.227 9.93635 15.4933 9.75705 15.7867 9.63466C16.0801 9.51228 16.3948 9.44925 16.7127 9.44922H20.1098V12.6776Z" fill="black" />
                      </svg>
                    </a>
                    <a href='https://www.instagram.com/pkcargouk/' target='_blank'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="33" viewBox="0 0 34 33" fill="none">
                        <ellipse cx="17.2926" cy="16.33" rx="16.6324" ry="16.33" fill="#F7B53C" />
                        <path d="M17.1849 12.3868C16.5225 12.3868 15.8751 12.5832 15.3243 12.9512C14.7736 13.3191 14.3444 13.8422 14.0909 14.4541C13.8374 15.066 13.7711 15.7394 13.9003 16.389C14.0295 17.0386 14.3485 17.6353 14.8169 18.1037C15.2852 18.572 15.8819 18.891 16.5315 19.0202C17.1812 19.1494 17.8545 19.0831 18.4664 18.8296C19.0784 18.5762 19.6014 18.1469 19.9694 17.5962C20.3373 17.0455 20.5338 16.398 20.5338 15.7357C20.5338 14.8475 20.1809 13.9957 19.5529 13.3676C18.9249 12.7396 18.0731 12.3868 17.1849 12.3868ZM17.1849 17.3373C16.8681 17.3373 16.5584 17.2434 16.295 17.0674C16.0317 16.8914 15.8264 16.6412 15.7051 16.3486C15.5839 16.0559 15.5522 15.7339 15.614 15.4232C15.6758 15.1125 15.8283 14.8271 16.0523 14.6031C16.2763 14.3791 16.5617 14.2266 16.8724 14.1648C17.1831 14.103 17.5051 14.1347 17.7978 14.2559C18.0905 14.3772 18.3406 14.5824 18.5166 14.8458C18.6926 15.1092 18.7865 15.4189 18.7865 15.7357C18.7846 16.1598 18.6152 16.5661 18.3153 16.8661C18.0153 17.166 17.6091 17.3354 17.1849 17.3373ZM20.6794 7.87305H13.6904C12.5319 7.87305 11.4208 8.33326 10.6017 9.15244C9.78248 9.97162 9.32227 11.0827 9.32227 12.2412V19.2301C9.32227 20.3886 9.78248 21.4997 10.6017 22.3189C11.4208 23.138 12.5319 23.5983 13.6904 23.5983H20.6794C21.8379 23.5983 22.9489 23.138 23.7681 22.3189C24.5873 21.4997 25.0475 20.3886 25.0475 19.2301V12.2412C25.0475 11.0827 24.5873 9.97162 23.7681 9.15244C22.9489 8.33326 21.8379 7.87305 20.6794 7.87305ZM23.3002 19.2301C23.3002 19.9252 23.0241 20.5919 22.5326 21.0834C22.0411 21.5749 21.3745 21.851 20.6794 21.851H13.6904C12.9953 21.851 12.3287 21.5749 11.8371 21.0834C11.3456 20.5919 11.0695 19.9252 11.0695 19.2301V12.2412C11.0695 11.5461 11.3456 10.8794 11.8371 10.3879C12.3287 9.89642 12.9953 9.62029 13.6904 9.62029H20.6794C21.3745 9.62029 22.0411 9.89642 22.5326 10.3879C23.0241 10.8794 23.3002 11.5461 23.3002 12.2412V19.2301ZM22.1354 11.95C22.1354 12.1803 22.0671 12.4055 21.9391 12.5971C21.8111 12.7887 21.6292 12.938 21.4163 13.0261C21.2035 13.1143 20.9693 13.1373 20.7433 13.0924C20.5174 13.0475 20.3098 12.9365 20.1469 12.7736C19.984 12.6107 19.8731 12.4032 19.8281 12.1772C19.7832 11.9512 19.8062 11.717 19.8944 11.5042C19.9826 11.2913 20.1319 11.1094 20.3234 10.9814C20.515 10.8534 20.7402 10.7851 20.9706 10.7851C21.2795 10.7851 21.5758 10.9078 21.7942 11.1263C22.0127 11.3447 22.1354 11.641 22.1354 11.95Z" fill="black" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Footer
